import { useState } from 'react';
import { BillingProvider } from '../types';

let selectedRecords: BillingProvider[] = [];
const listeners: (() => void)[] = [];

const notifyListeners = () => {
  listeners.forEach(listener => listener());
};

export const useBillingProvidersSelection = () => {
  const [, forceUpdate] = useState({});
  
  const rerender = () => forceUpdate({});
  
  if (!listeners.includes(rerender)) {
    listeners.push(rerender);
  }

  const setSelectedRecords = (records: BillingProvider[]) => {
    selectedRecords = records;
    notifyListeners();
  };

  const clearSelection = () => {
    selectedRecords = [];
    notifyListeners();
  };

  return {
    selectedRecords,
    setSelectedRecords,
    clearSelection,
    handleClearSelection: clearSelection,
    hasSelection: selectedRecords.length > 0
  };
};